<template>
    <div class="beer" v-if="beer">
        <div class="beer__grid">
            <div class="beer__content">
                <div class="meal-info">
                    <div class="meal-info__thb">
                        <div class="meal-info__thb__sizer">
                            <img :src="meal.img" v-if="meal.img" />
                        </div>
                    </div>
                    <div class="meal-info__desc">
                        <span class="name" v-html="meal.fullName || meal.name"></span>
                        <template v-if="meal.additives">
                            <a href="#" @click="additivesChange" v-if="(meal.additives.length > 0 || meal.souce.length > 0)"> {{ translate('change')}}</a>
                        </template>
                    </div>
                </div>
                <h3 v-text="translate('beer_dish')"></h3>
                <h1>{{beer.name}}</h1>
                <div class="beer__desc" v-html="sierotki(beer.content)">
                </div>
                <div class="info-items">
                    <div><span v-text="translate('alcohol')"></span> <strong><b>{{beer.alcohol}}%</b> {{ translate('alcohol_suffix') }}</strong></div>
                    <div><span v-text="translate('bitterness')"></span> <strong><b>{{ beer.ibu }}</b> {{ translate('bitterness_suffix') }}</strong></div>
                </div>

                <template  v-if="isZeroOption">
                    <span class="beer__sep" v-text="translate('and')"></span>
                    <h1>{{beer.name2}}</h1>
                    <div class="beer__desc" v-html="sierotki(beer.content2)">
                    </div>
                    <div class="info-items">
                        <div><span v-text="translate('alcohol')"></span> <strong><b>{{beer.alcohol2}}%</b> {{ translate('alcohol_suffix') }}</strong></div>
                        <div><span v-text="translate('bitterness')"></span> <strong><b>{{ beer.ibu2 }}</b> {{ translate('bitterness_suffix') }}</strong></div>
                    </div>
                </template>
            </div>
            <div class="beer__image" :class="[{ 'beer__image--zero' : isZeroOption}]">
                <img :src="beer.img" v-if="beer.img" />
            </div>
        </div>
        <div class="beer__reset">
            <button type="button" class="btn-link icon-refresh" @click="resetOptions" v-text="translate('beer_match')"></button>
        </div>
    </div>
</template>

<script>

import {translate} from "@/helpers/helpers";
export default {
    name: "beer-page",
    props: ['beers', 'beerId', 'meal'],
    computed: {
        beer() {
            if(this.beerId === null) return false;
            else return this.beers[this.beerId];
        },
        isZeroOption() {
            return this.beer.isZero == true;
        }
    },
    methods: {
        translate: translate,
        additivesChange() {
            this.$emit('onAdditivesChange');
        },
        resetOptions() {
            this.$emit('onClose');
        }
    }
}
</script>

<style scoped>

</style>